import { usingOpenFin } from 'app/openFin/OpenFinSupport.tsx';
import { useAppSelector } from 'store/hooks.ts';
import { selectEmbeddedAppState } from 'embedded/store/embeddedAppStateSlice.ts';

import React, { useCallback, useEffect, useState } from 'react';

import { WindowControlButtons } from 'utils/components/WindowControlButtons/WindowControlButtons';

import { _Window } from '@openfin/core/src/api/window';

export function OpenFinWindowButtons() {
    const [isMaximized, setIsMaximized] = useState(false);
    const [window, setWindow] = useState<undefined | _Window>();

    useEffect(() => {
        if (!usingOpenFin) {
            return;
        }
        const currentWindow = fin.Window.getCurrentSync();
        setWindow(currentWindow);

        currentWindow.getState().then((w) => setIsMaximized(w === 'maximized'));
    }, []);

    const hideWindowButtons = useAppSelector(
        (s) => selectEmbeddedAppState(s).hideWindowButtons
    );

    const onClickClose = useCallback(() => {
        window?.close(true);
    }, [window]);

    const onClickMinimize = useCallback(() => {
        window?.minimize();
    }, [window]);

    const onClickMaximizeRestore = useCallback(() => {
        if (isMaximized) {
            window?.restore();
            setIsMaximized(false);
        } else {
            window?.maximize();
            setIsMaximized(true);
        }
    }, [isMaximized, window]);

    if (!usingOpenFin || hideWindowButtons) {
        return <></>;
    }

    return (
        <WindowControlButtons
            isMaximised={isMaximized}
            onClickClose={onClickClose}
            onClickMinimize={onClickMinimize}
            onClickMaximizeRestore={onClickMaximizeRestore}
        />
    );
}
